import axios from "axios";
import Vue from 'vue';
import router from '../router';
import {
  baseUrl,
  getToken,
  removeToken,
  getPayChannel
} from "@/utils/auth";
import SysUtils from "@/utils/sysUtils";

// // 开发环境下使用固定的基础接口路径
// if (process.env.NODE_ENV === 'development') {}

// axios 配置
var request = axios.create({
  baseURL: baseUrl(),
  timeout: 20000 // 20s
})

var hide_loading = false;

/** 下一次请求不显示Loading */
request.hideLoadingOnce = function () {
  hide_loading = true;
}

/**
 * 是否隐藏Loading
 * @returns
 */
function isHideLoading() {
  var b = hide_loading;
  // 每次请求后都设置为不隐藏加载框
  hide_loading = false;
  return b;
}

// http request 拦截器
request.interceptors.request.use(
  config => {
    if (!isHideLoading()) {
      Vue.$vux.loading.show();
    }
    let userToken = getToken();
    if (userToken) {
      config.headers['accessToken'] = userToken;
    }
    let payChannel = getPayChannel();
    config.headers['payChannel'] = payChannel;
    return config;
  },
  error => {
    Vue.$vux.loading.hide();
    return Promise.reject(error);
  }
);

// http response 拦截器
request.interceptors.response.use(
  response => {
    Vue.$vux.loading.hide();
    var res = response.data;
    // 拿到当前接口的返回response，根据response.data中的fail字段判断当前接口调用是否正确
    if (res && (res.code == 0 || res.appId)) {
      return res;
    }
    // 当返回信息为未登录或者登录失效的时候重定向为登录页面
    // 微信环境下需要授权登录，此时判断code是否存在，如果存在，清空code，进入授权页，重新获取code
    if (res.code == 401) {
      Vue.$vux.alert.hide();
      removeToken();
      sessionStorage.clear();
      localStorage.clear();
      res.msg = "用户信息过期，请重新登录"; // 修改提示
      // 微信环境下重新授权登录
      if (SysUtils.isWeiXin()) {
        window.location.href = window.location.origin + window.location.pathname + "#/wxAuth";
      } else {
        router.push({
          path: "/login"
        })
      }
    } else if (res.code == '5001') {
      // 如果code为5001，说明系统正在维护中，进入维护提示界面
      router.push({
        path: "/maintain"
      })
    }
    // 如果失败，显示失败原因
    console.log("操作失败：--------------------");
    console.log(res);
    return Promise.reject(res);
  },
  error => {
    console.log(error)
    if (error.code == 'ECONNABORTED') {
      error.msg = "请求超时!";
    }
    error.msg = error.message;
    Vue.$vux.loading.hide();
    return Promise.reject(error)
  }
)

export default request;



// WEBPACK FOOTER //
// ./src/api/request.js